export * from './stat/stat.module';
export * from './page-header/page-header.module';



// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/shared/modules/index.ts